import { render, staticRenderFns } from "./PixExtract.vue?vue&type=template&id=f867f61a"
import script from "./PixExtract.vue?vue&type=script&lang=js"
export * from "./PixExtract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports